<template>
  <div class="footer-content__wrapper">
    <a-icon
      :icon="$options.consts.ICON.FM_INTELLIGENCE_LOGO"
      :to="fmIntelligenceUrl"
      :no-hover="true"
      :original="true"
      :open-in-new-tab="false"
      width="auto"
      height="auto"
      aria-label="Finance Magnates Intelligence"
      class="footer-content__qir-logo"
    />

    <a-image
      :src="fmLogo"
      :url="fmUrl"
      alt="Financial and Business News"
      title="Financial and Business News"
      class="footer-content__fm-logo"
    />

    <p class="footer-content__description">
      Finance Magnates Intelligence, part of Finance Magnates, delivers
      specialized research and insights on the financial markets. Offering
      Quarterly, Annual, and custom reports tailored to specific business needs,
      it covers key aspects such as trading volumes, market trends, regulations,
      and more.
    </p>

    <footer-socials class="footer-content__socials" />

    <ul class="footer-content__links">
      <li v-for="linkSettings in links" :key="linkSettings.link">
        <a-link
          :to="linkSettings.link"
          :open-in-new-tab="true"
          class="footer-content__link"
        >
          {{ linkSettings.text }}
        </a-link>
      </li>
    </ul>
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import FooterSocials from '@/components/_layout/AFooter/FooterSocials/index.vue'

export default {
  name: 'FooterContent',
  components: { FooterSocials, AIcon },
  consts: {
    ICON
  },
  data() {
    return {
      fmIntelligenceUrl: this.$helper.generateFmUrl('/intelligence/', this),
      fmLogo: this.$helper.getLinkToFmBucketFile('header-logo-3.svg'),
      fmUrl: this.$env.FM_DOMAIN_URL,
      links: [
        {
          link: this.$env.FM_DOMAIN_URL,
          text: 'Finance Magnates'
        },
        {
          link: this.$helper.generateFmUrl('/all-news/', this),
          text: 'Latest News'
        },
        {
          link: this.$env.FM_DIRECTORY_DOMAIN_URL,
          text: 'Directory'
        },
        {
          link: this.$helper.generateFmUrl('/events/', this),
          text: 'Events'
        },
        {
          link: this.$helper.generateFmUrl('/contact-us/', this),
          text: 'Contact Us'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';

.footer-content__wrapper {
  $grid-setup: (
    $columnSetup: (
      $above-desktop-xl: 194px minmax(0, 100%) 215px,
      $desktop-md: minmax(0, 100%) 191px,
      $mobile: minmax(0, 100%)
    ),
    $columnGapSetup: (
      $above-desktop-xl: 48px,
      $desktop-md: 72px,
      $mobile: 0
    ),
    $rowSetup: (
      $above-desktop-xl: 40px auto 30px,
      $desktop-md: 78px auto 30px,
      $mobile: repeat(5, auto)
    ),
    $rowGapSetup: (
      $desktop-md: 32px,
      $mobile: 0
    )
  );

  $grid-template-areas: (
    $above-desktop-xl: 'qir-logo description links' 'fm-logo description links'
      'fm-logo socials links',
    $desktop-md: 'qir-logo fm-logo' 'description links' 'socials socials',
    $mobile: 'qir-logo' 'fm-logo' 'description' 'socials' 'links'
  );

  @include setStyleByBreakpoint('grid-template-areas', $grid-template-areas);

  @include gridBuilder($grid-setup);

  .footer-content__qir-logo {
    grid-area: qir-logo;

    $width: (
      $above-desktop-xl: 194px
    );

    $height: (
      $above-desktop-xl: 32px
    );

    $margin: (
      $above-desktop-xl: 8px 0 0,
      $desktop-md: auto 0,
      $mobile: 40px 0 0
    );

    @include setStyleByBreakpoint('margin', $margin);
    @include setStyleByBreakpoint('height', $height);
    @include setStyleByBreakpoint('width', $width);
  }

  .footer-content__fm-logo {
    /deep/ img {
      width: 100%;
      height: 100%;
    }

    grid-area: fm-logo;

    $width: (
      $above-desktop-xl: 172px
    );

    $height: (
      $above-desktop-xl: auto,
      $desktop-md: 78px,
      $tablet: 78px,
      $mobile: auto
    );

    $margin-top: (
      $above-desktop-xl: 57px,
      $desktop-md: 0,
      $mobile: 48px
    );

    $margin-bottom: (
      $mobile: 32px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
    @include setStyleByBreakpoint('margin-top', $margin-top);
    @include setStyleByBreakpoint('height', $height);
    @include setStyleByBreakpoint('width', $width);
  }

  .footer-content__description {
    grid-area: description;
    color: $c--text-secondary;

    $font-size: (
      $above-desktop-xl: 18px
    );

    $line-height: (
      $above-desktop-xl: 28px
    );

    $margin-bottom: (
      $above-desktop-xl: 24px,
      $desktop-md: 0,
      $mobile: 24px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
    @include setStyleByBreakpoint('font-size', $font-size);
    @include setStyleByBreakpoint('line-height', $line-height);
  }

  .footer-content__socials {
    grid-area: socials;

    $margin-top: (
      $desktop-md: -8px,
      $mobile: 0
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }

  .footer-content__links {
    grid-area: links;

    $font-size: (
      $above-desktop-xl: 18px
    );

    $line-height: (
      $above-desktop-xl: 28px
    );

    $margin: (
      $above-desktop-xl: 0 auto,
      $desktop-md: 0,
      $mobile: 48px 0 0
    );

    @include setStyleByBreakpoint('margin', $margin);
    @include setStyleByBreakpoint('font-size', $font-size);
    @include setStyleByBreakpoint('line-height', $line-height);

    .footer-content__link {
      display: flex;
      color: $c--text-secondary;
      text-decoration: none;
    }
  }
}
</style>
